import { useEffect, useRef, useState } from 'react';
import { projetosData } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function Projetos() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState<Set<string>>(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('data-id');
            if (id) setVisible((prev) => new Set(prev).add(id));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );
    const cards = sectionRef.current?.querySelectorAll('[data-id]');
    cards?.forEach((c) => observer.observe(c));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="projetos"
      ref={sectionRef}
      className="bg-white py-28 md:py-36 lg:py-44"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="mb-14 md:mb-20">
          <span className="text-xs font-light uppercase tracking-[0.1em] text-marrom block mb-3">
            {projetosData.label}
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extralight text-black tracking-tight mb-5">
            {projetosData.title}
          </h2>
          <p className="font-body text-sm md:text-base font-light text-brand-gray-body leading-relaxed max-w-[520px]">
            {projetosData.description}
          </p>
        </div>

        {/* Asymmetric grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 items-stretch">
          {projetosData.projects.map((project) => (
            <Link
              key={project.id}
              to={`/projeto/${project.id}`}
              data-id={project.id}
              className={`group relative overflow-hidden ${project.span} ${
                visible.has(project.id)
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8'
              } transition-all duration-700 ease-editorial h-full`}
            >
              <div className="relative w-full h-full overflow-hidden">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover object-top transition-transform duration-[600ms] ease-in-out group-hover:scale-[1.03]"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex flex-col justify-end p-5 md:p-6">
                  <h3 className="font-display text-white text-lg md:text-xl font-light tracking-wide translate-y-3 group-hover:translate-y-0 transition-transform duration-300 ease-editorial">
                    {project.name}
                  </h3>
                  <span className="font-body text-white/70 text-xs font-light uppercase tracking-[0.1em] mt-1 translate-y-3 group-hover:translate-y-0 transition-transform duration-300 ease-editorial delay-75">
                    Ver galeria
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}